import React from 'react';
import { Search, Download, Share2 } from 'lucide-react';
interface TopBarProps {
  pageTitle: string;
}
export function TopBar({
  pageTitle
}: TopBarProps) {
  return <header className="bg-white border-b border-film-border h-12 flex items-center justify-between px-6 sticky top-0 z-10" data-id="element-1697">
      <div className="flex items-center gap-4" data-id="element-1698">
        <span className="font-mono text-xs text-film-gray" data-id="element-1699">Film Notes</span>
        <span className="text-film-gray/50" data-id="element-1700">·</span>
        <span className="font-mono text-xs text-film-black" data-id="element-1701">{pageTitle}</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-1702">
        <div className="relative" data-id="element-1703">
          <Search className="w-3.5 h-3.5 text-film-gray absolute left-2 top-1/2 -translate-y-1/2" data-id="element-1704" />
          <input type="text" placeholder="Search frames..." className="bg-film-cream border border-film-border pl-7 pr-3 py-1 text-xs font-mono w-48 focus:outline-none focus:border-film-gray" data-id="element-1705" />
        </div>
        <button className="px-3 py-1 bg-film-black text-white font-mono text-[10px] uppercase tracking-wider flex items-center gap-1.5 hover:bg-film-red transition-colors" data-id="element-1706">
          <Share2 className="w-3 h-3" data-id="element-1707" />
          Export to Figma
        </button>
        <button className="px-3 py-1 border border-film-border text-film-black font-mono text-[10px] uppercase tracking-wider flex items-center gap-1.5 hover:bg-film-cream transition-colors" data-id="element-1708">
          <Download className="w-3 h-3" data-id="element-1709" />
          PDF
        </button>
      </div>
    </header>;
}